module.exports = __webpack_public_path__ + "static/media/illustration-feedback.1171b784.svg";